module.exports = __webpack_public_path__ + "static/media/pic10.1f3772dd.jpg";